export const Config = {
    apiUrl: "https://www.merlijndussen.me:8080/api",
};
